import React from 'react';
import { NavLink } from 'react-router-dom';

const NavigationSettings = ({ currentWorkSite }) => {
  const activeClasses = 'bg-yellow-admin text-blue-admin rounded-lg p-3';
  const inactiveClasses = 'border border-gray-admin bg-white rounded-lg p-3 text-blue-admin';

  return (
    <div>
      <section className="md:pt-14 px-4 md:px-9">
        {/* Titre */}
        <div className="flex flex-col items-center justify-between border-b border-gray-admin pb-4 pt-11 md:pt-0 mb-4 md:flex-row">
          <h3 className="font-bold text-xl text-center md:text-left">
            {currentWorkSite?.name}
          </h3>
        </div>

        {/* Onglets */}
        <div className="pb-4 border-b pt-11 border-white-admin">
          <ul className="flex space-x-8">
            <li>
              <NavLink
                to="purchaseorder"
                state={currentWorkSite}
                className={({ isActive }) =>
                  isActive ? activeClasses : inactiveClasses
                }
              >
                Bons de commande
              </NavLink>
            </li>
            <li>
              <NavLink
                to="workorder"
                state={currentWorkSite}
                className={({ isActive }) =>
                  isActive ? activeClasses : inactiveClasses
                }
              >
                Bons d’intervention
              </NavLink>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default NavigationSettings;
